export default function Gallery(){
    return (
        <div style={{margin: "150px auto 0", maxWidth: "680px", border: "1px dashed black", padding: "24px"}}>
            Work samples coming soon... 
        </div>
    )
}